export default __webpack_public_path__ + "static/media/seongjaerok.9281ceef.png";